import React from 'react'
import { Row, Card } from 'antd'

interface FilterBarCardProps {
  children: React.ReactNode
}

// Shared search/filter-bar shell — same Card + Row wrapper AgreementList.tsx
// uses around its Input.Search + Select controls. Pages just drop their own
// <Col>...</Col> filter controls in as children; the controls themselves stay
// page-specific (different fields to filter on), only the outer chrome is shared.
const FilterBarCard: React.FC<FilterBarCardProps> = ({ children }) => (
  <Card
    style={{
      marginBottom: 16,
      borderRadius: 'var(--radius-lg, 12px)',
      boxShadow: 'var(--shadow-sm, 0 1px 2px rgba(11,20,38,0.06))',
      background: 'var(--surface-1, #fff)',
    }}
    styles={{ body: { padding: '16px 20px' } }}
  >
    <Row gutter={[16, 12]} align="middle">
      {children}
    </Row>
  </Card>
)

export default FilterBarCard
